module.exports = __webpack_public_path__ + "img/DINPro-Light.b0ccbeaf.svg";